import { Resources } from 'constants/resources';

import { AutocompleteInput, AutocompleteMultiselectInput } from 'shared/react-admin/Inputs';
import { ReferenceArrayInput } from 'shared/react-admin/ReferenceInputs';
import { Currency } from 'types/embedded/currency';

export const GatewaysCreateCurrenciesFields: React.FC = () => (
  <>
    <ReferenceArrayInput
      filter={{ active: true }}
      perPage={1000}
      reference={Resources.Currencies}
      sort={{ field: 'id', order: 'ASC' }}
      source="defaultCurrency"
    >
      <AutocompleteInput
        filterToQuery={(searchText: string) => ({ currency: searchText })}
        fullWidth
        isRequired
        label="Валюта по умолчанию"
        optionText={(record: Currency) => `${record?.alphaCode}, ${record?.name}`}
        size="small"
        variant="outlined"
      />
    </ReferenceArrayInput>
    <ReferenceArrayInput
      filter={{ active: true }}
      perPage={1000}
      reference={Resources.Currencies}
      sort={{ field: 'id', order: 'ASC' }}
      source="supportedCurrencies"
    >
      <AutocompleteMultiselectInput
        clearOnBlur={false}
        filterToQuery={(searchText: string) => ({ currency: searchText })}
        fullWidth
        getOptionLabel={(record: Currency) => `${record?.alphaCode}, ${record?.name}`}
        label="Поддерживаемые валюты"
        name="supportedCurrencies"
        size="small"
      />
    </ReferenceArrayInput>
  </>
);
